<template>
  <v-row justify="center" class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar height="60" dark class="elevation-0">
        <v-toolbar-title>{{ item.displayName }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card>
        <v-card-text class="pa-1">
          <v-row class="ma-0" align="center">
            <v-col cols="12">
              <v-text-field
                v-if="item.uid"
                label="UID"
                v-model="item.uid"
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" align="center">
              <v-avatar size="240" color="grey lighten-3">
                <img :src="item.photoURL"/>
              </v-avatar>
            </v-col>
            <v-col cols="12">
              <v-text-field
                id="name"
                ref="name"
                prepend-icon="person"
                label="name"
                class="ma-0 pa-0"
                v-model="item.displayName"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                id="email"
                ref="email"
                prepend-icon="email"
                label="Email"
                v-model="item.email"
                type="email"
                :disabled="type == 'delete'"
                :rules="[rules.required, rules.email]"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12">
              <v-text-field
                id="password"
                ref="password"
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                prepend-icon="lock"
                name="password"
                label="Password"
                v-model="password"
                :type="show1 ? 'text' : 'password'"
                :rules="item.uid ? [rules.password, rules.min] : [rules.required, rules.min]"
                @click:append="show1 = !show1"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                id="confirmPassword"
                ref="confirmPassword"
                :append-icon="show2 ? 'visibility' : 'visibility_off'"
                prepend-icon="lock"
                name="confirmPassword"
                label="Confirm password"
                v-model="confirmPassword"
                :type="show2 ? 'text' : 'password'"
                @click:append="show2 = !show2"
                :rules="item.uid ? [rules.password, rules.min] : [rules.required, rules.password, rules.min]"
              ></v-text-field>
            </v-col> -->
            <v-col cols="12">
              <v-switch v-model="item.disabled" color="error" :label="item.disabled ? '無効' : ''"></v-switch>
            </v-col>
            <v-col cols="12" align="end">
              <v-btn rounded depressed @click.native="onClose()">取消</v-btn>
              <v-btn rounded depressed color="error" @click.native="dialog = true">更新</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <div>
      <app-basic-dialog
        v-if='dialog'
        @dismissed="onDismissed"
        :title="'⚠️更新'"
        :message="'認証情報を更新します。よろしいですか?'"
        :dialog='dialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/storage'
import axios from 'axios'

export default {
  computed: {
    form () {
      if (this.type === 'add') {
        return {
          name: this.item.displayName,
          email: this.item.email,
          password: this.password,
          confirmPassword: this.confirmPassword
        }
      }
      return {
        name: this.item.displayName,
        email: this.item.email
      }
    }
  },
  data () {
    return {
      sizeKB: 5000,
      file: null,
      show1: false,
      show2: false,
      password: null,
      confirmPassword: null,
      formHasErrors: false,
      loading: false,
      dialog: false,
      rules: {
        required: value => !!value || '必須',
        password: value => value === this.password || '必須',
        min: value => (!!value && value.length >= 6) || '最低でも 6文字が必要です',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || '無効なメールアドレスです'
        }
      }
    }
  },
  props: [ 'item', 'type' ],
  created () {
  },
  methods: {
    storeFile: function (blob) {
      this.file = blob
    },
    onClose () {
      this.$emit('dismissed', { update: false })
    },
    onSubmit () {
      if (this.type === 'edit' || this.type === 'add') {
        this.formHasErrors = false
        Object.keys(this.form).forEach(f => {
          if (!this.form[f]) {
            this.formHasErrors = true
          }
          this.$refs[f].validate(true)
        })
        if (this.formHasErrors) {
          return
        }
      }
      var payload = {
        uid: this.item.uid,
        email: this.item.email,
        displayName: this.item.displayName,
        emailVerified: this.item.emailVerified,
        disabled: this.item.disabled
      }
      if (this.password) {
        payload['password'] = this.password
      }
      if (this.item.photoURL) {
        payload['photoURL'] = this.item.photoURL
      }
      var vm = this
      this.loading = true
      this.accounts = []
      var url = this.$FUNCTIONS_URL + 'user/update'
      firebase.auth().currentUser.getIdToken().then(function (token) {
        axios.post(url, payload, {
          headers: { 'Authorization': `Bearer ${token}` }
        }).then(function (response) {
          vm.loading = false
          vm.$emit('dismissed', { update: true })
        }).catch(function (error) {
          if (error) {
            // console.log(error)
          }
          vm.loading = false
          vm.$emit('dismissed', { update: false })
        })
      })
    },
    storeImage (blob) {
      return new Promise((resolve) => {
        var vm = this
        vm.loading = true
        var uuid = this.genUUIDv4()
        var storageRef = firebase.storage().ref().child('users').child(this.item.uid).child('avatar').child(uuid)
        var uploadTask = storageRef.put(blob)
        uploadTask.on('state_changed', function (snapshot) {
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              break
            case firebase.storage.TaskState.RUNNING: // or 'running'
              break
          }
        }, function (error) {
          vm.loading = false
          if (error) {
            // console.log(error)
          }
          resolve()
        }, function () {
          uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
            vm.loading = false
            resolve(downloadURL)
          })
        })
      })
    },
    onDismissed: function (value) {
      this.dialog = false
      if (value) {
        this.onSubmit()
      }
    }
  }
}
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
